<template>
  <div :class="$style.messagesParent">
    <div :class="$style.messagesGroup">
      <div :class="$style.searchContainer">
        <div :class="$style.searchParent">
          <img :class="$style.icon" alt="" src="/static/img/SearchIcon.svg" />
          <input
            :class="$style.inputPlaceholder"
            type="text"
            v-model="search"
            placeholder="Search..."
            @keyup="filterConversations"
          />
        </div>
        <div :class="$style.newWrapper">
          <img :class="$style.icon" alt="" src="/static/img/Write.svg" />
        </div>
      </div>
      <hr :class="$style.dividerLine" />
      <div :class="$style.conversationPreviewsWrapper">
        <div
          v-for="conversation of filteredConversations"
          v-bind:key="conversation.id"
        >
          <div
            :class="$style.conversationPreview"
            @click="selectConversation(conversation)"
          >
            <div :class="$style.messagesParent1">
              <div :class="$style.userIntialsWrapper">
                <b :class="$style.userIntials"
                  >{{ conversation.user.firstName[0]
                  }}{{ conversation.user.lastName[0] }}</b
                >
              </div>
              <div :class="$style.messagesParent2">
                <div :class="$style.userNameParent">
                  <div :class="$style.userName">
                    {{ conversation.user.firstName }}
                    {{ conversation.user.lastName }}
                  </div>
                  <div :class="$style.userTypeProgram">
                    {{ conversation.user.type }},
                    {{ conversation.user.program.name }}
                  </div>
                </div>
                <div :class="$style.div">
                  {{ formatDateTime(conversation.messages[0].createdAt) }}
                </div>
              </div>
            </div>
            <div :class="$style.messagePreviewWrapper">
              <div :class="$style.messagePreview">
                {{ conversation.messages[0].message }}
              </div>
            </div>
          </div>
          <hr :class="$style.dividerLine" />
        </div>
      </div>
    </div>
    <div
      :class="$style.conversationMessageListContainer"
      v-if="selectedConversation"
    >
      <div :class="$style.conversationMessageListHeader">
        <div :class="$style.listHeaderWrapper">
          <div :class="$style.userIntialsWrapper13">
            <b :class="$style.userIntials"
              >{{ selectedConversation.user.firstName[0]
              }}{{ selectedConversation.user.lastName[0] }}</b
            >
          </div>
          <div :class="$style.userNameParent13">
            <div :class="$style.userName">
              {{ selectedConversation.user.firstName }}
              {{ selectedConversation.user.lastName }}
            </div>
            <div :class="$style.userTypeProgram">
              {{ selectedConversation.user.type }},
              {{ selectedConversation.user.program.name }}
            </div>
          </div>
        </div>
        <img :class="$style.icon" alt="" src="/static/img/vertical_dots.svg" />
      </div>
      <div :class="$style.messageList" id="messageList">
        <div
          v-for="message of selectedConversation.messages"
          v-bind:key="message.id"
        >
          <div :class="$style.messageParent">
            <div
              v-if="message.fromUser.id !== currentUser.id"
              :class="$style.userIntialsWrapper"
            >
              <b :class="$style.userIntials"
                >{{ message.fromUser.firstName[0]
                }}{{ message.fromUser.lastName[0] }}</b
              >
            </div>
            <div
              :class="
                currentUser.id === message.fromUser.id
                  ? $style.userMessageContainer
                  : $style.messageContainer
              "
            >
              <div :class="$style.message">{{ message.message }}</div>
            </div>
          </div>
        </div>
      </div>
      <el-button
        v-if="notAtBottom"
        :class="$style.scrollButton"
        icon="el-icon-bottom"
        @click="scrollToBottom(true)"
      ></el-button>
      <div :class="$style.messagesWriteContainer">
        <div :class="$style.writeMessageWrapper">
          <input
            :class="$style.inputPlaceholder"
            type="text"
            v-model="newMessage"
            placeholder="Write message"
            @keyup.enter="sendNewMessage"
          />
        </div>
        <div :class="$style.sendIconWrapper">
          <img
            :class="$style.icon"
            alt=""
            src="/static/img/white-paper-airplane.svg"
            @click="sendNewMessage"
          />
        </div>
      </div>
    </div>
    <div :class="$style.conversationMessageListContainer" v-else></div>
    <coming-soon-modal />
  </div>
</template>
<script>
import { Button } from "element-ui";
import { useLoginStore } from "@/stores/loginStore";
import ComingSoonModal from "@/components/HiloComponents/ComingSoonModal.vue";

export default {
  components: {
    ComingSoonModal,
    [Button.name]: Button,
  },
  name: "Chat",
  data() {
    return {
      conversations: [],
      filteredConversations: [],
      test: false,
      selectedConversation: null,
      currentUser: this.useLoginStore().getUser,
      search: "",
      notAtBottom: false,
      newMessage: "",
    };
  },
  async mounted() {
    this.loadTestData();

    this.$nextTick(() => {
      const content = document.querySelector(".content");
      const viewHeight = document.body.clientHeight;

      if (content) {
        content.style.height = viewHeight - 110 + "px";
        content.style.minHeight = content.style.height;
        content.style.overflow = "hidden";
      }
    });
  },
  beforeDestroy() {
    const messageList = document.getElementById("messageList");

    if (messageList) {
      messageList.removeEventListener("scroll", this.checkScrollPosition);
    }

    this.$nextTick(() => {
      const content = document.querySelector(".content");

      if (content) {
        content.style.height = "";
        content.style.overflow = "";
        content.style.minHeight = "calc(100vh - 65px)";
      }
    });
  },
  methods: {
    useLoginStore,
    loadTestData() {
      this.conversations = [
        {
          id: 1,
          user: {
            firstName: "Keaton",
            lastName: "Harris",
            type: "Student",
            program: {
              name: "CFII",
            },
          },
          messages: [
            {
              id: 1,
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                id: 1,
                firstName: "Keaton",
                lastName: "Harris",
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
            {
              id: 2,
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                id: this.currentUser.id,
                firstName: this.currentUser.firstName,
                lastName: this.currentUser.lastName,
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
            {
              id: 3,
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                id: 1,
                firstName: "Keaton",
                lastName: "Harris",
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
            {
              id: 4,
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                id: this.currentUser.id,
                firstName: this.currentUser.firstName,
                lastName: this.currentUser.lastName,
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
            {
              id: 5,
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                id: 1,
                firstName: "Keaton",
                lastName: "Harris",
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
            {
              id: 6,
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                id: this.currentUser.id,
                firstName: this.currentUser.firstName,
                lastName: this.currentUser.lastName,
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
          ],
        },
        {
          id: 2,
          user: {
            firstName: "Tyler",
            lastName: "Johnson",
            type: "Instructor",
            program: {
              name: "Private",
            },
          },
          messages: [
            {
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                firstName: "Tyler",
                lastName: "Johnson",
                type: "Instructor",
                program: {
                  name: "Private",
                },
              },
            },
          ],
        },
        {
          id: 3,
          user: {
            firstName: "Keaton",
            lastName: "Harris",
            type: "Student",
            program: {
              name: "CFII",
            },
          },
          messages: [
            {
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                firstName: "Keaton",
                lastName: "Harris",
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
          ],
        },
        {
          id: 4,
          user: {
            firstName: "Tyler",
            lastName: "Johnson",
            type: "Instructor",
            program: {
              name: "Private",
            },
          },
          messages: [
            {
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                firstName: "Tyler",
                lastName: "Johnson",
                type: "Instructor",
                program: {
                  name: "Private",
                },
              },
            },
          ],
        },
        {
          id: 5,
          user: {
            firstName: "Keaton",
            lastName: "Harris",
            type: "Student",
            program: {
              name: "CFII",
            },
          },
          messages: [
            {
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                firstName: "Keaton",
                lastName: "Harris",
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
          ],
        },
        {
          id: 6,
          user: {
            firstName: "Tyler",
            lastName: "Johnson",
            type: "Instructor",
            program: {
              name: "Private",
            },
          },
          messages: [
            {
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                firstName: "Tyler",
                lastName: "Johnson",
                type: "Instructor",
                program: {
                  name: "Private",
                },
              },
            },
          ],
        },
        {
          id: 7,
          user: {
            firstName: "Keaton",
            lastName: "Harris",
            type: "Student",
            program: {
              name: "CFII",
            },
          },
          messages: [
            {
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                firstName: "Keaton",
                lastName: "Harris",
                type: "Student",
                program: {
                  name: "CFII",
                },
              },
            },
          ],
        },
        {
          id: 8,
          user: {
            firstName: "Tyler",
            lastName: "Johnson",
            type: "Instructor",
            program: {
              name: "Private",
            },
          },
          messages: [
            {
              createdAt: new Date(),
              message:
                "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat.",
              fromUser: {
                firstName: "Tyler",
                lastName: "Johnson",
                type: "Instructor",
                program: {
                  name: "Private",
                },
              },
            },
          ],
        },
      ];
      this.filterConversations();
    },
    formatDateTime(inputDate) {
      const now = new Date();
      const isToday = inputDate.toDateString() === now.toDateString();

      if (isToday) {
        return inputDate.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
      } else {
        return inputDate.toLocaleDateString();
      }
    },
    selectConversation(conversation) {
      this.selectedConversation = conversation;
      this.scrollToBottom();

      this.$nextTick(() => {
        const messageList = document.getElementById("messageList");

        if (messageList) {
          messageList.addEventListener("scroll", this.checkScrollPosition);
          this.checkScrollPosition();
        }
      });
    },
    checkScrollPosition() {
      const messageList = document.getElementById("messageList");

      if (messageList) {
        const isAtBottom = messageList.scrollTop >= -100;
        this.notAtBottom = !isAtBottom;
      }
    },
    scrollToBottom(smooth = false) {
      const messageList = document.getElementById("messageList");

      if (messageList) {
        const behavior = smooth ? "smooth" : "auto";
        messageList.scrollTo({ top: messageList.scrollHeight, behavior });
      }
    },
    filterConversations() {
      this.filteredConversations = this.conversations.filter(
        (data) =>
          !this.search ||
          (
            data.user.firstName.toLowerCase() + data.user.lastName.toLowerCase()
          ).includes(this.search.toLowerCase()),
      );
    },
    sendNewMessage() {
      this.newMessage = "";
      alert("New Message Sent");
    },
  },
};
</script>
<style module scoped>
img {
  cursor: pointer;
}
.icon {
  width: 24px;
  position: relative;
  height: 24px;
  overflow: hidden;
  flex-shrink: 0;
}
.inputPlaceholder {
  position: relative;
  line-height: 25px;
  background-color: transparent;
  border: none;
  width: 100%;
}
.searchParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.1);
  height: 40px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  box-sizing: border-box;
  gap: 10px;
}
.newWrapper {
  width: 40px;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.1);
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.searchContainer {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px;
  gap: 10px;
  text-align: center;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.5);
}
.frameChild {
  align-self: stretch;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
}
.userIntials {
  position: relative;
}
.userIntialsWrapper {
  width: 50px;
  border-radius: 50px;
  background-color: #ff8585;
  height: 50px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.userName {
  align-self: stretch;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.userTypeProgram {
  align-self: stretch;
  position: relative;
  font-size: 13px;
  color: rgba(64, 64, 64, 0.5);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.userNameParent {
  width: 144px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.div {
  position: relative;
  font-size: 13px;
  color: rgba(64, 64, 64, 0.5);
  text-align: right;
}
.messagesParent2 {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0px 0px 0px 10px;
  font-size: 18px;
  color: #404040;
}
.messagesParent1 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.messagePreview {
  flex: 1;
  position: relative;
  display: -webkit-inline-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.messagePreviewWrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 0px 0px 60px;
  font-size: 13px;
  color: #404040;
}
.conversationPreviewsWrapper {
  overflow-y: auto;
}
.conversationPreview {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px 10px;
  cursor: pointer;
}
.frameChild5 {
  align-self: stretch;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  height: 0px;
  flex-shrink: 0;
}
.messagesGroup {
  align-self: stretch;
  width: 350px;
  background-color: #f6f6f6;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.userIntialsWrapper13 {
  width: 40px;
  border-radius: 40px;
  background-color: #ff8585;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.userNameParent13 {
  width: 144px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #404040;
}
.listHeaderWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.vectorIcon1 {
  width: 1.7px;
  position: relative;
  height: 13.3px;
  object-fit: contain;
}
.conversationMessageListHeader {
  align-self: stretch;
  background-color: rgba(64, 64, 64, 0.15);
  height: 60px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  box-sizing: border-box;
}
.message {
  align-self: stretch;
  position: relative;
  line-height: 25px;
}
.messageContainer {
  flex: 1;
  border-radius: 20px 20px 20px 5px;
  background-color: rgba(64, 64, 64, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px 20px;
  font-size: 15px;
  color: #404040;
  margin-right: 25%;
  margin-left: 0;
}
.userMessageContainer {
  flex: 1;
  border-radius: 20px 20px 5px 20px;
  background-color: #3c78ff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 15px 20px;
  font-size: 15px;
  color: white;
  margin-left: 25%;
  margin-right: 0;
}
.messageParent {
  width: 100%;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0 0 0 25px;
  gap: 10px;
}
.frameIcon {
  align-self: stretch;
  max-width: 100%;
  overflow: hidden;
  height: 205px;
  flex-shrink: 0;
  object-fit: contain;
}
.messageList {
  align-self: stretch;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 25px 0px;
  gap: 20px;
  font-size: 25px;
}
.writeMessageWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.1);
  height: 40px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  box-sizing: border-box;
}
.sendIconWrapper {
  width: 40px;
  border-radius: 10px;
  background-color: #3c78ff;
  height: 40px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.messagesWriteContainer {
  align-self: stretch;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 10px 30px;
  gap: 10px;
  text-align: center;
  font-size: 18px;
  color: rgba(64, 64, 64, 0.5);
}
.conversationMessageListContainer {
  align-self: stretch;
  flex: 1;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 20px;
}
.messagesParent {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  font-size: 25px;
  color: #fff;
  font-family: Helvetica, Arial, sans-serif;
}
.dividerLine {
  border: 0;
  border-top: 1px solid #ddd;
  height: 0;
  margin: 5px 0;
  width: 100%;
  box-sizing: border-box;
}
.scrollButton {
  position: absolute;
  right: 50px;
  bottom: 100px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border-color: transparent;
  color: white;
  background-color: #bfcacb;
  font-size: 28px;
  padding: 0;
}
</style>
